<template>
  <div class="share-component-button" :class="position ? '' : 'absolute'">
    <button
      class="share-component-button__button"
      :class="position ? '' : 'absolute'"
      @click="isOpen = !isOpen"
    >
      <img :src="buttonIcon" />
    </button>
    <div v-if="isOpen"
         class="share-component-button__dropdown"
         :class="position ? '' : 'absolute'"
    >
      <div class="share-component-button__dropdown__inner">
        <div class="share-component-button__title">
          SHARE ON
        </div>
        <ul class="share-component-button__links">
          <li>
            <a href="#" @click="fbShare">
              <span>
                <img :src="FacebookIcon" />
              </span>
              <span>FACEBOOK</span>
            </a>
          </li>
          <li>
            <a href="#" @click="twitterShare">
              <span>
                <img :src="TwitterIcon" />
              </span>
              <span>TWITTER</span>
            </a>
          </li>
          <li v-if="canShare">
            <a href="#" @click="shareBrowser">
              <span>
                <img :src="ListIcon" />
              </span>
              <span>SHARE</span>
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="copyLink">
              <span>
                <img :src="LinkIcon" />
              </span>
              <span>COPY LINK</span>
            </a>
          </li>
        </ul>
      </div>
      <div v-if="isCopied" class="toaster">
        <div class="toaster__inner">
          <div class="toaster__inner__msg">
            <span>Copied!</span>
            <span>
              <img :src="TickIcon" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import ShareIcon from '@/assets/icons/svg/share.svg';
import CloseIcon from '@/assets/icons/svg/close.svg';
import FacebookIcon from '@/assets/icons/svg/social/icon-tw-mr.svg';
import TwitterIcon from '@/assets/icons/svg/social/icon-fb-mr.svg';
import LinkIcon from '@/assets/icons/svg/link.svg';
import ListIcon from '@/assets/icons/svg/list-vert.svg';
import TickIcon from '@/assets/icons/svg/tick.svg';

export default {
  name: 'ShareButton',
  props: {
    position: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      isOpen: false,
      isCopied: false,
      url: '',
      ShareIcon: ShareIcon,
      CloseIcon: CloseIcon,
      FacebookIcon: FacebookIcon,
      TwitterIcon: TwitterIcon,
      LinkIcon: LinkIcon,
      ListIcon: ListIcon,
      TickIcon: TickIcon
    };
  },
  computed: {
    canShare() {
      return navigator.canShare ? true : false;
    },
    buttonIcon() {
      return this.isOpen ? CloseIcon : ShareIcon;
    }
  },

  created() {
    const location = document.location;
    this.url = location.origin + location.pathname;
  },

  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.url).then(
        () => {
          this.isCopied = true;
          this.debounce();
        },
        () => {
          console.error('Error on copy link');
        }
      );
    },

    debounce: _.debounce(function() {
      this.isCopied = false;
    }, 1000),

    fbShare() {
      console.log(this.url);
      window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + this.url,
        'facebook-share-dialog',
        'width=800,height=600'
      );
    },

    twitterShare() {
      console.log(this.url);
      window.open('https://twitter.com/intent/tweet?url=' + this.url);
    },
    async shareBrowser() {
      const data = {
        title: 'MovementRadio',
        text: 'MovementRadio',
        url: this.url
      };
      try {
        await navigator.share(data);
        console.log('MDN shared successfully');
      } catch (err) {
        console.log(err);
      }

      //   navigator.share(this.url);
      //   console.log('share');
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_share-button.scss';
</style>
